export default __webpack_public_path__ + "static/media/pluss.ffde5b0f.svg";